import { Breadcrumb } from './breadcrumb';
import { BreadcrumbFields } from "./breadcrumb.fields";
import type { BreadcrumbProps } from './breadcrumb';
import type { ComponentConfig } from '@puckeditor/core';

const BreadcrumbConfig: ComponentConfig<BreadcrumbProps> = {
  defaultProps: {
    items: [
      { label: "Home", url: "/" },
      { label: "Services", url: "/services/" },
      { label: "Current Page", url: "" },
    ],
    separator: "chevron",
    showHomeIcon: true,
  },
  fields: {
    showHomeIcon: BreadcrumbFields.showHomeIcon,
    separator: BreadcrumbFields.separator,
    items: BreadcrumbFields.items as any,
  },
  label: "Breadcrumb",
  render: ({ id, puck, editMode: _editMode, ...props }) => {
    const siteUrl: unknown = puck?.metadata?.site?.url;

    return <Breadcrumb id={id} {...props} baseUrl={typeof siteUrl === "string" ? siteUrl : undefined} />;
  },
};

export { BreadcrumbConfig };
